import { render, staticRenderFns } from "./NotificationTooltipWrapper.vue?vue&type=template&id=74797856&scoped=true&"
import script from "./NotificationTooltipWrapper.vue?vue&type=script&lang=js&"
export * from "./NotificationTooltipWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74797856",
  null
  
)

export default component.exports